export function OutlinePerifoneoIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1929 10.5739L12.771 15.4609L16.8448 18.3134L20.2667 13.4264L16.1929 10.5739Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.8525 4.54534L3 8.61914L5.4435 10.3301L8.296 6.2563L5.8525 4.54534Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0292 17.7433L12.7725 15.4629L10.4921 18.7196L13.7488 20.9999L16.0292 17.7433Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7732 15.4616L3.16089 13.5859L10.5729 3C11.3939 4.10727 12.21 5.20978 13.0309 6.31705C14.0857 7.73933 15.1405 9.15683 16.1905 10.5791C15.0498 12.2066 13.9091 13.8389 12.7684 15.4664L12.7732 15.4616Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
